import { useState } from "react"
import { Container, Row, Col } from "reactstrap"

import { getCashCounterAccount, getCashCounterRegister } from "services/tickets"
import { getCurrentCashOperationDay } from "services/cash-operation-days"

import DashboardSummaryCards from "./components/DashboardSummaryCards"
import DashboardOverviewChart from "./components/DashboardOverviewChart"
import DashboardProductsSection from "./components/DashboardProductsSection"
import DashboardCashChart from "./components/DashboardCashChart"
import DashboardRecentTickets from "./components/DashboardRecentTickets"
import { buildSummaryCards } from "./dashboard-data"
import useDashboardQuery from "./useDashboardQuery"

const Dashboard = () => {
  document.title = "Dashboard | Punto de venta"
  const [selectedMonth, setSelectedMonth] = useState(() => new Date().toISOString().slice(0, 7))

  const cashOperationDayQuery = useDashboardQuery(["cash-operation-day-current"], () => getCurrentCashOperationDay())
  const cashRegisterQuery = useDashboardQuery(["cash-register-balance"], () => getCashCounterRegister())
  const cashAccountQuery = useDashboardQuery(["cash-account-balance"], () => getCashCounterAccount())

  const summaryCards = buildSummaryCards({
    salesSummary: cashOperationDayQuery.data?.sales_summary,
    cashRegister: cashRegisterQuery.data || { cash: 0 },
    cashAccount: cashAccountQuery.data || { cash: 0 },
  })

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-4">
          <Col xs="12">
            <h2 className="mb-1">Dashboard</h2>
            <p className="mb-0 text-muted">Resumen general del negocio</p>
          </Col>
        </Row>

        <DashboardSummaryCards cards={summaryCards} />

        <Row className="g-3 mt-1">
          <Col xl="6" lg="12" xs="12">
            <DashboardOverviewChart />
          </Col>
          <Col xl="6" lg="12" xs="12">
            <DashboardProductsSection />
          </Col>
        </Row>

        <Row className="g-3 mt-1">
          <Col xl="8" lg="12" xs="12">
            <DashboardCashChart selectedMonth={selectedMonth} onSelectedMonthChange={setSelectedMonth} />
          </Col>
          <Col xl="4" lg="12" xs="12">
            <DashboardRecentTickets />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Dashboard